export default __webpack_public_path__ + "static/media/condition-explorer-tab-icon.2c2f56e6.svg";